import React from "react";

import { useNavigate } from "react-router-dom";
import Footer from "../includes/Footer";
import Sidebar from "../includes/Sidebar";
import $ from "jquery";
import { useFormik } from "formik";
import { addSite } from "../../../schema";
import { useState } from "react";
import AdminListService from "../../../services/admin-list.service";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { CKEditor } from "ckeditor4-react";
import he from "he";

export default function AddCutomer() {
  const state = useSelector((state) => state.stateVals);

  const { admin_id } = state;

  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [changeColor, setChangeColor] = useState(false);

  const [landingLogo, setLandingLogo] = useState("");
  const [homeLogo, setHomeLogo] = useState("");
  const [thankLogo, setThankLogo] = useState("");
  const [emailLogo, setEmailLogo] = useState("");

  const changeIt = (e) => {
    if (e.target.checked) {
      $(".change-color").fadeOut();
      $(".c-color").css("color", "#000");
      setChangeColor(true);
    } else {
      $(".change-color").fadeIn();
      $(".c-color").css("color", "#fff");
      setChangeColor(false);
    }
  };

  const handleLandingLogoUpload = async (e) => {
    setLandingLogo(e.target.files[0]);
  };

  const handleHomeLogoUpload = async (e) => {
    setHomeLogo(e.target.files[0]);
  };

  const handleThankLogoUpload = async (e) => {
    setThankLogo(e.target.files[0]);
  };
  const handleEmailLogoUpload = async (e) => {
    setEmailLogo(e.target.files[0]);
  };

  const addSiteCustomer = async (values, action) => {
    setLoading(true);

    var backgroundGrade = await $("#target").css("background-image");
    var cleanColor = await backgroundGrade.replace(/-webkit-/g, "");

    const formData = new FormData();
    formData.append("logoImage", landingLogo);
    formData.append("logoImage1", homeLogo);
    formData.append("logoImage2", thankLogo);
    formData.append("emailLogo", emailLogo);
    formData.append("AdminId", parseInt(admin_id));

    formData.append("url", values.url);
    formData.append("redeemedMsg", values.message);
    formData.append("emailSubject", values.subject);
    formData.append("emailBody", he.encode(values.body));
    formData.append("username", values.userName);
    formData.append("email", values.email);
    formData.append("password", values.password);
    formData.append("siteName", values.siteName);
    formData.append("productType", values.pedType);
    formData.append("naVisio", values.visio);
    formData.append(
      "gradxCode",
      "background:" +
        cleanColor +
        "; \n" +
        "background: -o-" +
        cleanColor +
        "; \n" +
        " background: -ms-" +
        cleanColor +
        "; \n" +
        "background: -moz-" +
        cleanColor +
        "; \n" +
        "background: -webkit-" +
        cleanColor
    );
    formData.append("changeColor", changeColor);

    try {
      const responce = await AdminListService.siteCustomerAdd(formData);

      if (responce.status === 200) {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Added Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });

        setTimeout(() => {
          navigate("/site_manage");
        }, 1500);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (
        err?.response?.data?.message &&
        typeof err?.response?.data?.message === "string"
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          iconColor: "#e04f5d",
          text: err?.response?.data?.message,
          confirmButtonColor: "#e72e2e",
          confirmButtonText: "Try Again",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          iconColor: "#e04f5d",
          text: "Some thing went wrong!",
          confirmButtonColor: "#e72e2e",
          confirmButtonText: "Try Again",
        });
      }
    }
  };

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      siteName: "",
      userName: "",
      password: "",
      email: "",
      visio: "",
      pedType: "",
      url: "",
      message:
        "Your Reward Card order has been received, and is beingshipped to the address below. If any of this information is incorrect please contact us info@gw-resttest-56.com",
      subject: "",
      body: '<table align="center" border="0" cellpadding="10" style="margin-top:50px; width:900px"><tbody><tr><td colspan="2" style="text-align:center"><img alt="logo" src="https://images-cloud.s3.ap-south-1.amazonaws.com/evoucherthanks.PNG" /></td></tr><tr><td colspan="2" style="text-align:center"><span style="color:#0000FF"><span style=" color: rgb(46, 116, 181);font-family:times new roman,times,serif"><span style="font-size:28px"><strong>$sitename</strong></span></span></span></td></tr><tr><td colspan="2" style="text-align:center"><span style="font-size:20px"><strong>To redeem your gift card go to<br /><a href="https://gw-resttest-56.com" style="color: rgb(46, 116, 181); text-decoration: none;">www.gw-resttest-56.com</a></strong></span></td></tr><tr><td colspan="2" style="text-align:center"><span style="color:rgb(178, 34, 34)"><span style="font-size:18px"><strong>PLEASE do not forget to write down your certificate number BEFORE entering the site.</strong></span></span></td></tr><tr><td colspan="2" style="text-align:center"><div class="background" style="font-size: 18px;"><strong><span style="font-size:20px">Voucher #</span>:</strong> <span style="font-size:20px"><span style="color:rgb(178, 34, 34)">$cert</span></span>            <strong><span style="font-size:20px">Voucher Value</span>:</strong> <span style="font-size:20px"><span style="color:rgb(178, 34, 34)">$val</span></span></div></td></tr><tr><td colspan="2" style="text-align:center"><table align="center" border="0" cellpadding="5" style="color:rgb(65, 65, 65); font-size:26px; width:900px"><tbody><tr><td style="text-align:center"><span style="font-family:times new roman,times,serif"><span style="color:rgb(128, 128, 128)">$Cards_name</span></span></td></tr></tbody></table></td></tr><tr><td colspan="2" style="text-align:center"><table align="center" border="0" cellpadding="5" style="color:rgb(65, 65, 65); font-size:18px; width:900px"><tbody><tr><td style="text-align:center"><strong>Offer not valid after Expiration Date of</strong><span style="color:rgb(0, 0, 0)"><strong>:</strong> $expiry date</span></td></tr></tbody></table></td></tr><tr><td colspan="2">      <strong>Reward CardTerms and Conditions:</strong><ul><li>Elite Rewards reserves the right to substitute a comparable reward card.</li><li>Only one voucher can be redeemed per household per month.</li><li>All taxes are the responsibility of the person receiving the redemption.</li><li>Once your voucher is redeemed allow 2-4 weeks for processing and delivery. The card you selected will be sent to you via the US Postal Service or by email where virtual-cards are available. Failure to adhere to all Terms & Conditions may hinder the processing of your reward card.</li><li>No duplicates of this voucher will be accepted.</li><li>Failure to complete any line of online redemption form will result in this voucher being returned to you and will cause a delay in processing.<br />.</li></ul></td></tr><tr><td colspan="2" style="text-align:center"><h3><strong>For Questions related to gift cards please call 1-866 ELITE-21</strong></h3><br/><br/><p style="text-align:left"><strong>FST No. for Elite Rewards: ST 39966</strong></p></td></tr></tbody></table>',
    },
    validationSchema: addSite,
    onSubmit: (values, action) => {
      addSiteCustomer(values, action);
    },
  });

  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />

          <div className="card">
            <div className="card-header py-3">
              <h5 className="mb-0 font-22">
                Add Customer
                <button
                  type="button"
                  className="btn btn-primary d-inline-block float-end btn-sm"
                  onClick={() => navigate(-1)}
                >
                  Go Back
                </button>
              </h5>
            </div>

            <div className="card-body">
              <form className="row g-3" onSubmit={handleSubmit} noValidate>
                <div className="col-12 col-md-4">
                  <label className="form-label">Site Name </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Site Name"
                    name="siteName"
                    value={values.siteName || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.siteName && touched.siteName ? (
                    <span className="text-danger">{errors.siteName}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Username</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Username"
                    name="userName"
                    value={values.userName || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.userName && touched.userName ? (
                    <span className="text-danger">{errors.userName}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Password </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Password"
                    name="password"
                    value={values.password || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.password && touched.password ? (
                    <span className="text-danger">{errors.password}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Email </label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email"
                    name="email"
                    value={values.email || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.email && touched.email ? (
                    <span className="text-danger">{errors.email}</span>
                  ) : null}
                </div>

                <div className="col-12 col-md-4">
                  <label className="form-label">Na-visio Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Na-visio Number"
                    name="visio"
                    value={values.visio || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.visio && touched.visio ? (
                    <span className="text-danger">{errors.visio}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">Product Type</label>
                  <select
                    className="form-select"
                    name="pedType"
                    value={values.pedType || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Product Type</option>
                    <option value="Ordinary PYP">Ordinary PYP</option>
                    <option value="Gorilla PYP">Gorilla PYP</option>
                  </select>
                  {errors.pedType && touched.pedType ? (
                    <span className="text-danger">{errors.pedType}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">
                    Url <strong>*</strong>
                  </label>
                  <input
                    type="url"
                    className="form-control"
                    placeholder="Url"
                    name="url"
                    value={values.url || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.url && touched.url ? (
                    <span className="text-danger">{errors.url}</span>
                  ) : null}
                </div>
                <div className="col-12 col-md-4">
                  <label className="form-label">
                    Message for Redeemed voucher:
                  </label>
                  <textarea
                    type="number"
                    className="form-control"
                    name="message"
                    value={values.message || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  ></textarea>
                  {errors.message && touched.message ? (
                    <span className="text-danger">{errors.message}</span>
                  ) : null}
                </div>

                <div className="col-12 col-md-4">
                  <label htmlFor="formFileMultiple" className="form-label">
                    landing page logo
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    onClick={(e) => {
                      e.target.value = null;
                      setLandingLogo("");
                    }}
                    onChange={handleLandingLogoUpload}
                    accept=".png, .jpg, .jpeg"
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Home page logo
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    onClick={(e) => {
                      e.target.value = null;
                      setHomeLogo("");
                    }}
                    onChange={handleHomeLogoUpload}
                    accept=".png, .jpg, .jpeg"
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Thankyou logo
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    onClick={(e) => {
                      e.target.value = null;
                      setThankLogo("");
                    }}
                    onChange={handleThankLogoUpload}
                    accept=".png, .jpg, .jpeg"
                  />
                </div>
                <div className="col-12 col-md-4">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Auto Generated Email logo
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    onClick={(e) => {
                      e.target.value = null;
                      setEmailLogo("");
                    }}
                    onChange={handleEmailLogoUpload}
                    accept=".png, .jpg, .jpeg"
                  />
                </div>

                <div className="col-12 col-md-7">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Auto Generated Email Subject
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    name="subject"
                    value={values.subject || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.subject && touched.subject ? (
                    <span className="text-danger">{errors.subject}</span>
                  ) : null}
                </div>

                <div className="col-12 col-md-12">
                  <label htmlFor="formFileMultiple" className="form-label">
                    Email body
                  </label>

                  <CKEditor
                    initData={values.body || ""}
                    config={{
                      allowedContent: true,
                      versionCheck: false,

                      toolbar: [
                        ["Source"],
                        ["Styles", "Format", "Font", "FontSize"],
                        [
                          "Cut",
                          "Copy",
                          "Paste",
                          "PasteText",
                          "PasteFromWord",
                          "-",
                          "Undo",
                          "Redo",
                        ],
                        [
                          "Bold",
                          "Italic",
                          "Strike",
                          "UnderLine",
                          "RemoveFormat",
                        ],
                        ["Link", "Unlink", "Anchor"],
                        [
                          "NumberedList",
                          "BulletedList",
                          "-",
                          "Outdent",
                          "Indent",
                          "-",
                          "Blockquote",
                          "CreateDiv",
                          "-",
                          "JustifyLeft",
                          "JustifyCenter",
                          "JustifyRight",
                          "JustifyBlock",
                          "-",
                          "BidiLtr",
                          "BidiRtl",
                          "Language",
                        ],
                        ["EasyImageUpload"],
                        ["TextColor", "BGColor"],
                        ["Maximize", "ShowBlocks"],
                      ],
                      extraPlugins: "easyimage",
                      removePlugins: "image",
                      cloudServices_uploadUrl:
                        "https://33333.cke-cs.com/easyimage/upload/",
                      cloudServices_tokenUrl:
                        "https://33333.cke-cs.com/token/dev/ijrDsqFix838Gh3wGO3F77FSW94BwcLXprJ4APSp3XQ26xsUHTi0jcb1hoBt",
                    }}
                    onInstanceReady={() => {}}
                    onChange={(e) => {
                      var data = e.editor.getData();

                      setFieldValue("body", data);
                    }}
                  />
                </div>

                <div className="col-md-12">
                  <div className="wrap-colors">
                    <div id="gradX"></div>
                    <div className="targets">
                      <div className="target" id="target">
                        <div className="target_text">Target #1</div>
                      </div>
                      <div className="target" id="target2">
                        <div className="target_text">Target #2</div>
                      </div>
                    </div>
                    <div className="change-color"></div>
                    <div className="checkbox ">
                      <label className="c-color">
                        <input
                          type="checkbox"
                          name="change-color"
                          className="change form-check-input"
                          onChange={changeIt}
                        />{" "}
                        Enable Site Colors Editing.
                      </label>
                    </div>
                  </div>
                </div>

                <hr />

                <div className="col-md-4 m-0">
                  <div className="d-flex h-100 w-100 align-items-end mb-mob">
                    <button className="btn btn-primary w-100">
                      Save Customer Record
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
